import { AppThunkAction } from './appThunkAction';
import { EngagementCallUsageSummary } from '../../models/dto/engagementCallUsage';
import { AppDispatch } from './appDispatch';
import api from '../../helpers/api';

const pollingInterval = 10000;

export function initializeEngagementUsagePolling(engagementId: number): AppThunkAction {
    return (dispatch, getState) => {
    	const state = getState().engagementsUsage.byId.get(engagementId);
    	if (state?.initialized) return;
    	
    	pollUsage(engagementId, dispatch);
    	dispatch({ type: 'engagements-usage/initialized', engagementId });
	};
}

function pollUsage(engagementId: number, dispatch: AppDispatch): void {
	api.get<EngagementCallUsageSummary>(`/api/engagements/${engagementId}/call-usage`).then(response => {
		dispatch({ type: 'engagements-usage/updated', engagementId, usage: response.data });
		
		if (!response.data.isEngagementComplete) {
			setTimeout(() => pollUsage(engagementId, dispatch), pollingInterval);		
		}
	}, () => {
		setTimeout(() => pollUsage(engagementId, dispatch), pollingInterval);
	});
}

export interface EngagementUsageInitialized {
    type: 'engagements-usage/initialized';
    engagementId: number;
}

export interface EngagementUsageUpdated {
    type: 'engagements-usage/updated';
    engagementId: number;
    usage: EngagementCallUsageSummary;
}

export type EngagementsUsageActions = EngagementUsageInitialized | EngagementUsageUpdated;
